
import moment from "moment";
import Detail from "./Detail.vue";
import ShiftDetail from "./ShiftDetail.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
const profile = namespace("profile");
const schedule = namespace("schedule");
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { useAppInsights } from '../../store/modules/AppInsights'
 @Component({
    components: {
            Detail,
            ShiftDetail,
            Loading
        },
    })
export default class TradeShift extends Vue {
  data: {
    oldOffset: number;
    searchNameDate: string;
    shiftMembers: never[];
    potentialMembers: never[];
    filteredPotentialMembers: never[];
    stage: string;
    checkedPotential: never[];
    activePageNumber: number;
    potentialMemberLoading: boolean;
    assignmentLoaded: boolean;
    shiftDetailLoaded: boolean;
    totalResultCount: number;
    displayPages: number[];
    totalPageCount: number;
    shiftOffers: Array<any>,
    cachPotentialTrades: Array<any>;
    searchStartDate: string;
    searchEndDate: string;
    searchFirstName: string;
    searchLastName: string;
    recommendedShiftsOnly:boolean;
    isInitialLoad: boolean;
} = {
    oldOffset: 0,
    searchNameDate: "",
    shiftMembers: [],
    potentialMembers: [],
    filteredPotentialMembers: [],
    stage: "todo",
    checkedPotential: [],
    activePageNumber: 1,
    potentialMemberLoading: false,
    assignmentLoaded: false,
    shiftDetailLoaded: false,
    totalResultCount: 0,
    displayPages: [],
    totalPageCount: 0,
    shiftOffers: [],
    cachPotentialTrades: [],
    searchStartDate: "",
    searchEndDate: "",
    searchFirstName: "",
    searchLastName: "",
    recommendedShiftsOnly: true,
    isInitialLoad: true
  };
  $refs!: {            
            Detail:any;
        };  
  @profile.State profileData!: any;
  @profile.State
  isAdmin!: boolean;
  @Prop() currentEvent: any;
  @schedule.State public assignmentDetail!: any;
  @profile.State appInsightEventData!: any;
  isLoaded: boolean = false;
  processMode: boolean = false;
  isProductive: boolean = false;
  isLoading:boolean = false;
  loaderColor: string = "#0085ca";
  showTrainingVideo: boolean = false;
    @profile.State
    isImpersonating!: boolean;

  mounted() {        
    if(this.currentEvent.status== "Scheduled" && this.currentEvent.type == "Assignment"){
      this.getAssignmentDetail();
    } else {
      this.isProductive = true;
      this.getShiftTradeOffer();
    }
  }

  FireAction() {
    if(this.data.stage == "withdraw") {
      this.withdrawPotentialTrade();
      return;
    }
    if (
      (this.data.stage == "completed" &&
        this.data.checkedPotential.length == 0) ||
      (this.processMode && this.data.stage == "completed")
    ) {
      return;
    }
    if (this.data.stage == "completed") {
      this.createShiftOffer();
    }
    if(this.data.stage == "todo") {
      this.data.stage = "completed";
    }
  }

  async getShiftTradeOffer() {
    var payload = { 
        username: this.profileData.username, 
        shiftTradeOfferId:  this.currentEvent.id, 
    };

    await this.$store.dispatch("schedule/getShiftTradeOffer", payload)
      .then((res) =>  {
        this.data.shiftOffers = res.data;
        if(this.data.shiftOffers?.length > 0) {
          this.data.stage = "withdraw";
          this.getPotetialTradeAssignment();
        } else {
              this.getAssignmentDetail();
        }
        this.data.shiftDetailLoaded = true
      })
  }

  getGuidforCreateShift() {
            var uuidValue = "", k, randomValue;
            for (k = 0; k < 32; k++) {
                randomValue = Math.random() * 16 | 0;
                if (k == 8 || k == 12 || k == 16 || k == 20) {
                    uuidValue += "-"
                }
                uuidValue += (k == 12 ? 4 : (k == 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
            }
            return uuidValue;
  }

  createShiftOffer() {
    let requestBody: any[] = [];
    const checkedPotential: any = this.data.checkedPotential;
    checkedPotential.forEach(checked => {
            requestBody.push({
                id: this.getGuidforCreateShift(),
                username: this.profileData.username,
                firstName: this.profileData.first,
                lastName: this.profileData.last,
                tenantId: this.profileData.tenantId,
                scheduleId: this.assignmentDetail.scheduleId,
                facilityId: this.assignmentDetail.facilityId,
                coid: this.profileData.coid,
                facilityName: this.profileData.facilityName,
                departmentId: this.profileData.deptId,
                facilityCoId: this.assignmentDetail.facilityCoId,
                departmentName: this.assignmentDetail.departmentCode,
                departmentCode: this.profileData.deptCode,
                departmentShiftId: this.assignmentDetail.departmentShiftId,
                shiftCode: this.assignmentDetail.shiftCode,
                shiftDescription: this.assignmentDetail.shiftDescription,
                skill:checked.skill,
                date: this.currentEvent.date,
                startTime: this.assignmentDetail.startTime,
                endTime: this.assignmentDetail.endTime,
                actualStartTime: this.assignmentDetail.actualStartTime,
                actualEndTime: this.assignmentDetail.actualEndTime,
                hours: this.assignmentDetail.hours,
                minutes: this.assignmentDetail.minutes,
                status: 'Offered',
                requestorAssignmentId: this.assignmentDetail.id,
                productiveType: this.assignmentDetail.productiveType,
                acceptorAssignmentId: checked.assignmentId,
                offeredToUsername:  checked.staffUsername,
                offeredToFirstName: checked.firstName,
                offeredToLastName: checked.lastName,
                isAutoapprovable: checked.isAutoapprovable
            });
    });

    this.isLoading = true;
    this.$store
      .dispatch("schedule/createShiftTradeOffers", requestBody)
      .then((res) => {
        if (res.status === 200) {
            this.isLoading = false;
            this.$emit('showSuccessMsgPopUp', true);
            this.$emit('closeSharedModal');
        }
      })
      .catch((err: any) => {
        if (err) {
           this.isLoading = false;
           console.log(err); // Handle errors any way you want
           let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;                
           this.$refs.Detail.showErrorMsg = true;                            
          this.$refs.Detail.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
        }        
      })
      .finally(() => {
        this.isLoading = false;
        this.processMode = false;
        // this.$emit('closeSharedModal');
      });
  }

  withdrawPotentialTrade() {
    this.isLoading = true;
    this.$store
      .dispatch("schedule/withdrawPotentialTrade", this.assignmentDetail.id)
      .then(() => {
        this.isLoading = false;
        this.$emit('showSuccessMsgPopUp', true);
        this.$emit('closeSharedModal');
      })
      .catch((err: any) => {
        if (err) {
          this.isLoading = false;
          console.log(err); // Handle errors any way you want          
          let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;                        
          this.$refs.Detail.showErrorMsg = true;                            
          this.$refs.Detail.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
        }         
      });
  }

  async getAssignmentDetail() {
    var payload = { 
      username: this.profileData.username, 
      id: this.currentEvent.id
    };  

    await this.$store.dispatch("schedule/getAssignmentDetail", payload);
    this.data.assignmentLoaded = true;
    this.data.shiftDetailLoaded = true;    
    this.isProductive = (this.assignmentDetail.productiveType == "Productive" || this.assignmentDetail.productiveTypeId == 1) ? true : false;     
    
    if(this.data.assignmentLoaded && this.data.shiftDetailLoaded && this.isProductive){
      this.showTrainingVideo = true;
    }
  }

  async getPotetialTradeAssignment(offsetVal = 0, searchFirstNameLike = '', searchLastNameLike = '',searchStartDate='', searchEndDate='') {
    const checkIfCached = this.data.cachPotentialTrades.find((trades) => this.data.activePageNumber == Number(Object.keys(trades)[0]));
    if(checkIfCached) {
      this.handlePotentialShiftResponse(checkIfCached[this.data.activePageNumber]);
      this.data.cachPotentialTrades.pop();
      return;
    }
    this.data.potentialMemberLoading = true;
    this.isLoading = true;
    await this.$store
      .dispatch("schedule/getPotetialTradeAssignment", {              
        assignmentId: this.currentEvent.id,
        currentPage:  Math.ceil(offsetVal/6) > 1 ? Math.ceil(offsetVal/6) : 1,
        autoApprovableOnly: this.data.recommendedShiftsOnly,
        searchFirstNameLike:searchFirstNameLike,
        searchLastNameLike:searchLastNameLike,
        searchStartDate:searchStartDate,
        searchEndDate:searchEndDate,
        primaryDeptOnly:false

      }).then((response) => {
              this.isLoading = false;
              if(response) {
                if(this.data.activePageNumber == 1) {
                  this.data.totalResultCount = response.length > 0 ? response[0].totalResultCount : 0;
                  this.data.totalPageCount = Math.ceil(this.data.totalResultCount/6); // here 6 is current page display limit
                }

                this.handlePotentialShiftResponse(response);
              }
              this.data.potentialMemberLoading = false;
              this.data.assignmentLoaded = true;
      });
  }

  handlePotentialShiftResponse(response) {
    this.data.potentialMembers = response;
    this.data.filteredPotentialMembers = response;
    this.data.shiftOffers?.forEach(potential => {
      this.onPotentialChecked({assignmentId: potential.acceptorAssignmentId});
    });
  }

  selectedPotential(assignment) {
    const checkedPotential: any = this.data.checkedPotential;
    return checkedPotential.some((potential) => potential.assignmentId == assignment.assignmentId);
  }

  get progressStatus() {
    return this.data.stage; // todo calculate class
  }

  showNextPage() {
    // todo pagenumber to dynamic and show next three
    if (this.$refs.Detail.showErrorMsg) {
      this.$refs.Detail.showErrorMsg = false;
      this.$refs.Detail.errorMsg = "";
    }  
  }

  loadOffset(action: string) {
    this.data.searchNameDate = '';
    let resultOffset = 0;
    const lastPotentialMember: any = this.data.potentialMembers[this.data.potentialMembers.length-1];
    resultOffset = this.data.activePageNumber * 6;
    if(action == 'next' &&   resultOffset != lastPotentialMember.totalResultCount) {      
      this.data.cachPotentialTrades.push({[this.data.activePageNumber]: this.data.potentialMembers});
      this.data.activePageNumber = this.data.activePageNumber + 1;
      this.getPotetialTradeAssignment(resultOffset + 1,this.data.searchFirstName, this.data.searchLastName,this.data.searchStartDate);
    } else if(action == 'back' && this.data.activePageNumber != 1) {
      resultOffset = Number(Object.keys(this.data.cachPotentialTrades[this.data.cachPotentialTrades.length -1])[0]);
      this.data.activePageNumber = this.data.activePageNumber - 1;
      this.getPotetialTradeAssignment(resultOffset,this.data.searchFirstName,this.data.searchLastName,this.data.searchStartDate);
    }
   
    if (this.$refs.Detail.showErrorMsg) {
      this.$refs.Detail.showErrorMsg = false;
      this.$refs.Detail.errorMsg = "";
    }  
  }

  search() {
    this.data.isInitialLoad = false;
    if (this.data.searchNameDate == "") {
      this.getPotetialTradeAssignment();
      return;
    }
  
  // check if its a date search
   let isDateSearch = false;

    if(moment(this.data.searchNameDate).isValid()){
      isDateSearch = true;
      this.data.searchStartDate = (moment(this.data.searchNameDate).format('MM-DD-YYYY')).toString();
    }

    if(isDateSearch){    
        // date search        
        this.getPotetialTradeAssignment(0,'','',this.data.searchStartDate); 
        this.data.searchFirstName = "";
        this.data.searchLastName = "";      
    } else {
      this.data.searchStartDate = "";
      // name search
      const regex = /\d/;
      if(regex.test(this.data.searchNameDate)){
        // invalid search term - not a date nor a name 
        this.data.filteredPotentialMembers = this.data.potentialMembers;
        return;
      }

      var nameSearch = this.data.searchNameDate.split(" ");      
      const alphaRegex =  /^[a-zA-Z()]+$/;
     

      if(nameSearch.length == 1){
        
        this.data.searchFirstName = this.data.searchNameDate;
        this.data.searchLastName = this.data.searchNameDate;
        
        if(!alphaRegex.test(this.data.searchFirstName)){
          
          this.data.filteredPotentialMembers = this.data.potentialMembers;
          return;
        }

        this.getPotetialTradeAssignment(0,this.data.searchFirstName,this.data.searchLastName);
       
      } else {
        
        this.data.searchFirstName =nameSearch[0].substring(0,30);
        this.data.searchLastName = nameSearch[1].substring(0,30);
        const isFirstNameIsAlphabetic = alphaRegex.test(this.data.searchFirstName);
        const isLastNameAlphabetic = alphaRegex.test(this.data.searchLastName)
        
        if(!isFirstNameIsAlphabetic && !isLastNameAlphabetic){
          
          this.data.filteredPotentialMembers = this.data.potentialMembers;
          return;
        
        } else if(isFirstNameIsAlphabetic && !isLastNameAlphabetic){

          this.getPotetialTradeAssignment(0,this.data.searchFirstName);

        }else if(isLastNameAlphabetic && !isFirstNameIsAlphabetic){

          this.getPotetialTradeAssignment(0,'',this.data.searchLastName);

        }else{

          this.getPotetialTradeAssignment(0,this.data.searchFirstName,this.data.searchLastName);          
        }
       
      }
    
    }

    if (this.$refs.Detail.showErrorMsg) {
      this.$refs.Detail.showErrorMsg = false;
      this.$refs.Detail.errorMsg = "";
    }  
  }

  formatAssignmentTime(date: Date): string {
    return moment(date).format("ddd, MMM D - h:mm A");
  }

  formatDate(date: Date): string {
    return moment(date).format("ddd, MMM D");
  }
  formatTime(t: Date): string {
    return moment(t).format("h:mm A");
  }
  onPotentialChecked(potential) {
    const checkedPotential: any = this.data.checkedPotential;
    if (!checkedPotential.some(e => e.assignmentId === potential.assignmentId)) {
      checkedPotential.push(potential);
    } else {
      const filteredOne = this.data.checkedPotential.filter((potentials: any) => {
        return potential.assignmentId != potentials.assignmentId;
      });
      this.data.checkedPotential = filteredOne;
    }
    if (this.$refs.Detail.showErrorMsg) {
      this.$refs.Detail.showErrorMsg = false;
      this.$refs.Detail.errorMsg = "";
    }  
  }

  clearSearch(){    
    this.data.searchNameDate = '';    
      // reset search
      this.data.searchFirstName = "";
      this.data.searchStartDate = "";
      this.data.searchLastName = "";
  }
}
